import styled from 'styled-components'
import { colors, spacing } from '../../styles/_var'

export const DateCardWrapper = styled.div``

export const DateCardHeader = styled.div`
  padding-bottom: ${spacing.xs};
  border-bottom: solid 1px ${colors.lightBlack};
  display: flex;
`